// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import TacticsBoardPreset from "./tactics_board_preset_type";
import TacticsTimeControl from "./tactics_time_control_type";
import TacticsTimeIncrement from "./tactics_time_increment_type";

export default {
  userId: __t.u64(),
  get boardPreset() {
    return TacticsBoardPreset;
  },
  maxRevealsPerTurn: __t.u8(),
  get timeControl() {
    return TacticsTimeControl;
  },
  get timeIncrement() {
    return TacticsTimeIncrement;
  },
  chordingEnabled: __t.bool(),
  hostOnlyReset: __t.bool(),
  regionId: __t.string(),
};
